import { GradientType } from '../modules/Properties/types';
import { Gradients } from './materials/Gradients';

/** Subset of PointCloudOctree from potree for use in property change functions */
interface PotreePointCloud {
  material: {
    activeAttributeName: string | null;
    intensityRange: number[];
    size: number;
    gradient: unknown;
    gradientName: string;
  };
  pcoGeometry: {
    dataChunkCache?: Map<string, { level: number; pointsAmount: number }>;
  };
  downSamplingLevel: number;
  resolvedPoints: number;
  getAttribute(name: string): { name: string; range: [number | number[], number | number[]]; initialRange: [number, number] } | null;
}

export const DATA_DEPTH = 7;

export enum EnumAppearanceTypes {
  RGBA = 'rgba',
  CLASSIFICATION = 'classification',
  HEIGHT = 'height',
  INTENSITY = 'intensity gradient',
  SOURCE = 'source',
}

export const changePointCloudResolution = ({ pointCloud, value }: { pointCloud: PotreePointCloud | null | undefined; value: number }) => {
  if (!pointCloud || !pointCloud?.material) return;
  pointCloud.downSamplingLevel = value;

  const dataChunkCache = pointCloud.pcoGeometry.dataChunkCache;
  const chunks = dataChunkCache ? [...dataChunkCache.values()].filter((chunk) => chunk.level === value + DATA_DEPTH) : [];
  pointCloud.resolvedPoints = chunks.reduce((sum, chunk) => {
    return sum + chunk.pointsAmount;
  }, 0);
};

export const changePointCloudAppearance = ({ pointCloud, value }: { pointCloud: PotreePointCloud | null | undefined; value: EnumAppearanceTypes }) => {
  if (!pointCloud || !pointCloud?.material) return;
  pointCloud.material.activeAttributeName = value;

  const attribute = pointCloud.getAttribute(value);

  const isIntensity = attribute ? ['intensity', 'intensity gradient'].includes(attribute.name) : false;

  if (isIntensity && attribute) {
    if (pointCloud.material.intensityRange[0] === 0 && pointCloud.material.intensityRange[1] === 0) {
      pointCloud.material.intensityRange = attribute.range as number[];
    }
  }
};

export const changePointCloudGradient = ({ pointCloud, gradient }: { pointCloud: PotreePointCloud | null | undefined; gradient: GradientType }) => {
  if (!pointCloud || !pointCloud?.material) return;
  pointCloud.material.gradient = Gradients[gradient];
  pointCloud.material.gradientName = gradient;
};
